module.exports = __webpack_public_path__ + "static/media/cu.1df86dff.png";